// MB3 PIM assets live in an S3 bucket that is also fronted by a Fastly CDN which
// performs on-the-fly resizing and format conversion (?width=&quality=&format=).
// Upstream services return raw S3 origin URLs, which ignore those params and
// serve full-size JPEG originals. Rewriting the host to the CDN lets the
// front-end's image params (see formatImageSource) actually take effect.
const PIM_S3_HOSTS = [
  'materialbank-pim.s3.us-west-2.amazonaws.com',
  'materialbank-pim.s3.amazonaws.com',
]
const PIM_CDN_HOST = 'materialbank-pim-cdn.global.ssl.fastly.net'

// Rewrites a PIM S3 origin URL to its Fastly CDN equivalent. Any URL that isn't a
// known PIM S3 host (already on the CDN, a different host, or unparseable) is
// returned as-is. Matching on the parsed hostname (rather than a substring)
// avoids rewriting URLs where the host string only appears in the path/query.
export function toCdnImageUrl(url: string): string {
  if (!url) {
    return url
  }

  let hostname: string

  try {
    hostname = new URL(url).hostname
  } catch {
    return url
  }

  if (!PIM_S3_HOSTS.includes(hostname)) {
    return url
  }

  return url.replace(hostname, PIM_CDN_HOST)
}
